import React, { useEffect, useState } from "react";

import axios from "axios";
import moment from "moment";
import { Link, Navigate } from "react-router-dom";
import { Modal } from "../../components/Modal/Modal.component";
import Aside from "../../components/Aside/Aside";
import { Profile, Services, GivenTraffic, Units } from "../../types";
import Notification from "../../components/Alert/notification";
import SuccessNotification from "../../components/Alert/success_notification";

import classNames from "classnames";
import { TailSpin } from "react-loader-spinner";

import DatePicker from "react-date-picker";
//import DatePicker from 'react-date-picker/dist/entry.nostyle';

import { userSchema } from "../../validation/UserValidation";

interface DashboardPageProps { }

interface Contracts {
  inn: string
  juridical: string
  OwnerUUID: string
  contractUUID: string
}

const Dashboard: React.FC<DashboardPageProps> = () => {
  const [isModalOpen, setModalState] = React.useState(false);
  const toggleModal = () => setModalState(!isModalOpen);

  const [valueStart, onChangeStart] = useState(new Date());
  const [valueEnd, onChangeEnd] = useState(
    new Date(new Date().setDate(new Date().getDate() + 90))
  );

  const [profile, setProfile] = useState<Profile>();
  //const [traffic, setTraffic] = useState<GivenTraffic>();
  const [traffic, setTraffic] = useState<GivenTraffic>();

  const [service, setService] = useState<Services[]>();
  const [turboData, setTurboData] = useState(0);
  const [units, setUnits] = useState<Units>();
  const [sumIncTraffic, setSumIncTraffic] = useState(0);
  const [sumOutTraffic, setSumOutTraffic] = useState(0);

  const [contracts, setContracts] = React.useState<Contracts>()
  const [isOpenJuridicalBillForm, setisOpenJuridicalBillForm] = useState(false);
  const [isActiveButtonCreateBill, setActiveButtonCreateBill] = useState(true);
  const [NumNumber1c, setNumNumber1c] = useState("");
  const [IsBlockedButton, setIsBlockedButton] = useState(true);

  const [payReq, setPayreq] = useState("");
  const [errEmail, setErrEmail] = useState("");

  const [mount, setMount] = useState("");
  const [email, setEmail] = useState("");

  const [notification, setNotification] = useState(false);
  const [successNotification, setSuccessNotification] = useState(false);
  const [errors, setErrors] = useState("");

  const [isLoaded, setLoaded] = useState(false);
  const [isLoadingSheet, setIsLoadingSheet] = useState(false);
  const [isPay, setIsPay] = useState(true);


  const [sheetActive, setSheetActive] = useState(false);
  const [isActiveBlockedButton, setIsActiveBlockedButton] = useState(true);

  useEffect(() => {
    async function fetchTariff() {
      //await axios.post("v1/traffic/all").then((res) => setTraffic(res.data));
      await axios
        .get("v1/services/all")
        .then((res) => { setService(res.data.services); setTurboData(res.data.turboID); });
      const { data: profile } = await axios.get("v1/profile/info");
      setProfile(profile);
      await axios
        .post("v1/services/payment_required", {
          account_id: `${profile?.basicAccount}`,
        })
        .then((res) => {
          setPayreq(res.data.required_payment);
          setLoaded(true);
        });
      axios.get("v1/traffic/traffic/given").then((res) => {
        setSumIncTraffic(res.data.trafficIncNull + res.data.trafficInc);
        setSumOutTraffic(res.data.trafficOutNull + res.data.trafficOut);
        setTraffic(res.data);
      });
      axios
        .post("v1/traffic/traffic/units", {
          user_id: profile?.id,
        })
        .then((res) => {
          setUnits(res.data);
        });
    }
    fetchTariff();
  }, []);

  if (profile?.tariffName === "Стартовый Ямал")
    return <Navigate to="/inet/activate" />;

  const ActiveButtonBlocked = () => {
    setIsActiveBlockedButton(false);
  };

  const PayOn = async (event: any) => {
    event.preventDefault();
    setIsPay(false);

    let formData = {
      amount: event.target[0].value,
      email: event.target[1].value,
    };

    const isValid = await userSchema.isValid(formData);

    try {
      if (isValid) {
        const res = await axios.post("https://pay.lansat.ru/api/pay", {
          // const res = await axios.post("v1/services/payment", {
          account_id: profile?.basicAccount,
          email: `${!email ? profile!.email : email}`,
          amount: `${!mount ? parseFloat(payReq).toFixed(0) : mount}`,
          user_id: profile?.id,
        });

        window.location.href = res.data.url;
      } else {
        setIsPay(true);
        setErrEmail("Укажите корректный адрес электронной почты.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const settingActivateButtonBill = async () => {
    try {
      setIsLoadingSheet(true);
      setActiveButtonCreateBill(false)
      await axios.post('v1/profile/accounts/create', { inn: profile?.taxNumber, contract_id: profile?.contractID }).then((res) => {
        setIsLoadingSheet(false);
        setisOpenJuridicalBillForm(true)
        setContracts(res.data)
      });

      console.log(contracts)
    } catch (e) {
      console.log(e);
    }
  }

  const activatedDisabledBlocked = async () => {
    try {
      await axios
        .post("v1/profile/lockedDisable ", {
          account_id: profile?.basicAccount
        })
        .then((res) => {
          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking end date less than start date"
          ) {
            setErrors(
              "Невозможно установить блокировку: дата окончания блокировки меньше даты начала"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }
          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking end date less than start date"
          ) {
            setErrors(
              "Невозможно установить блокировку: дата окончания блокировки меньше даты начала"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking period too long"
          ) {
            setErrors(
              "Невозможно установить блокировку: период блокировки слишком большой"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking period too short"
          ) {
            setErrors(
              "Невозможно установить блокировку: период блокировки слишком короткий"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: previous voluntary block still active"
          ) {
            setErrors(
              "Невозможно установить добровольную блокировку: предыдущая добровольная блокировка все еще активна"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (res.data.message === "OK") {
            axios.get("v1/profile/info").then((res) => setProfile(res.data));
            setModalState(false);
            setErrors("Счет успешно разблокирован.");
            setSuccessNotification(true);
            setTimeout(() => {
              setSuccessNotification(false);
            }, 5000);
          }
        });
      // console.log("Start date:", startTime);
      // console.log("End date:", endTime);
    } catch (err) {
      console.log(err);
    }
  }

  const activeBlocked = async () => {
    const startTime = (valueStart.getTime() / 1000).toFixed(0);
    const endTime = (valueEnd.getTime() / 1000).toFixed(0);

    try {
      await axios
        .post("v1/profile/lockenable", {
          account_id: profile?.basicAccount,
          start: parseFloat(startTime),
          end: parseFloat(endTime),
        })
        .then((res) => {
          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking end date less than start date"
          ) {
            setErrors(
              "Невозможно установить блокировку: дата окончания блокировки меньше даты начала"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }
          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking end date less than start date"
          ) {
            setErrors(
              "Невозможно установить блокировку: дата окончания блокировки меньше даты начала"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking period too long"
          ) {
            setErrors(
              "Невозможно установить блокировку: период блокировки слишком большой"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: blocking period too short"
          ) {
            setErrors(
              "Невозможно установить блокировку: период блокировки слишком короткий"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (
            res.data.message ===
            "Unable to set voluntary blocking: previous voluntary block still active"
          ) {
            setErrors(
              "Невозможно установить добровольную блокировку: предыдущая добровольная блокировка все еще активна"
            );
            setModalState(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }

          if (res.data.message === "OK") {
            axios.get("v1/profile/info").then((res) => setProfile(res.data));
            setModalState(false);
            setErrors("Счет успешно заблокирован.");
            setSuccessNotification(true);
            setTimeout(() => {
              setSuccessNotification(false);
            }, 5000);
          }
        });
      // console.log("Start date:", startTime);
      // console.log("End date:", endTime);
    } catch (err) {
      console.log(err);
    }
  };

  const changeTurbo = async (serviceId: number, turboId: number) => {
    try {
      await axios
        .post("v1/services/turbo", {
          slink_id: serviceId,
          tms_id: turboId,
        })
        .then((res) => {
          if (res.data.message === "error while activating turbo mode") {
            setErrors("Режим турбо уже включен.");
          }

          if (res.data.message === "lack of funds for account") {
            setErrors("Недостаточно средств на счете.");
          }

          if (res.data.message === "OK") {
            setErrors("Режим турбо успешно включен.");
          }

          setNotification(true);
          setTimeout(() => {
            setNotification(false);
          }, 5000);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const startTime = new Date(new Date().setDate(1));
  const unixStartTime = (startTime.getTime() / 1000).toFixed(0);


  const getAccountPDF = async (nameSheet: string) => {
    try {
      axios({
        url: "v1/profile/bill/download",
        // data: { name: `${NumNumber1c}` },
        data: { name: nameSheet },
        method: "POST",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `счет_${NumNumber1c}.pdf`);
        document.body.appendChild(link);
        link.click();

      });
    } catch (err) {
      console.log(err);
    }
  };

  const createAccounts = async () => {
    try {
      setisOpenJuridicalBillForm(false);
      setIsLoadingSheet(true);
      await axios.post('v1/profile/bill/create', {
        uuidContract: contracts?.contractUUID,
        price: mount.toString(),
        uuid: contracts?.OwnerUUID,
        uuidAccountID: profile?.basicAccount.toString(),
        ip: profile?.IP,
        account_id: profile?.basicAccount

      }).then((res) => {
        if (res.data['success'] === false) {
          setIsLoadingSheet(false);
          setErrors("Ошибка при вызове конструктора (УникальныйИдентификатор): Недопустимое значение параметра (параметр номер '1')")
          setIsBlockedButton(true)

        }
        if (res.data['success'] === true) {
          setIsLoadingSheet(false);
          setSheetActive(true);
          setErrors("")
          setNumNumber1c(res.data['message'])
          setIsBlockedButton(true)
          getAccountPDF(res.data['message'])
        }

      })
    } catch (e) {
      console.log(e)
    }
  }

  return isLoaded ? (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Modal
        title={"Добровольная блокировка"}
        isOpen={isModalOpen}
        onClose={toggleModal}
      >
        Вы действительно хотите активировать? <br />с{" "}
        <span style={{ fontWeight: 600, color: "rgb(228, 54, 54)" }}>
          {moment(+valueStart).format("D.MM.YYYY")}г.
        </span>{" "}
        по{" "}
        <span style={{ fontWeight: 600, color: "rgb(228, 54, 54)" }}>
          {moment(+valueEnd).format("D.MM.YYYY")}г.
        </span>
        <div style={{ marginTop: "10px" }}>
          <button
            type="button"
            className="el-button el-button--danger el-button--small"
            onClick={toggleModal}
          >
            <span>
              <small>Нет</small>
            </span>
          </button>
          <button
            type="button"
            className="el-button el-button--success el-button--small"
            onClick={activeBlocked}
          >
            <span>
              <small>Да</small>
            </span>
          </button>
        </div>
      </Modal>
      <Aside isJurical={profile?.isJuridical} />
      <div data-v-dde546dc="" className="el-main">
        <div data-v-dde546dc="" className="dashboard">
          <h1>Личный кабинет</h1>
          {/* <span style={{"color": "red"}}>
            <p style={{"textAlign": "center", "fontSize": "16px"}}>Уважаемые Абоненты!</p> 
            с 1го мая для получения информационных сообщений (смс и e-mail) о балансе Вам необходимо ВКЛЮЧИТЬ данную опцию в личном кабинете. Опция бесплатная, по умолчанию она ВЫКЛЮЧЕНА. Также рекомендуем проверить актуальность Вашего номера мобильного телефона и e-mail указанных в личном кабинете.
          </span> */}
          <div>
            <div>

              <div className="gutters cards el-row el-row--flex">
                <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                  <div className="el-card is-always-shadow card--success">
                    <div className="el-card__header">
                      <div>
                        <i
                          aria-hidden="true"
                          className="fas fa-ruble-sign card__icon card__icon--small"
                        ></i>
                        <div className="flex justify-between">

                          <div>
                            <small style={{ fontWeight: 400, fontSize: 15 }}>
                              Баланс на сегодня
                            </small>
                            <h2 className="card-title">{profile?.balance} ₽</h2>
                          </div>
                          <div>
                            <small
                              style={{
                                fontWeight: 400,
                                fontSize: 15,
                                textTransform: "uppercase",
                              }}
                            >
                              в {moment().format("H:mm")}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="el-card__body">
                      <div className="flex justify-between align-center">
                        <div>
                          <Link to="/payment/history">
                            <button
                              type="button"
                              className="el-button el-button--success el-button--small"
                            >
                              <span>
                                <small>История платежей</small>
                              </span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                  <div className="el-card card--warning traffic-card py16 is-always-shadow">
                    <div className="el-card__header">
                      <div style={{ height: "100%" }}>
                        <i
                          aria-hidden="true"
                          className="fas fa-exchange-alt card__icon"
                          style={{ marginTop: -4 }}
                        ></i>
                        <div
                          className="flex justify-between"
                          style={{ height: "100%" }}
                        >
                          <div className="text-left">
                            <small style={{ fontWeight: 400, fontSize: 15 }}>
                              Входящий
                            </small>
                            <h2 className="card-title">
                              {sumIncTraffic.toFixed(0)} Мб
                            </h2>
                            <small
                              style={{
                                fontWeight: 400,
                                fontSize: 15,
                                textTransform: "lowercase",
                              }}
                            >
                              c {moment.unix(+unixStartTime).format("D.MM.Y")}г.
                            </small>
                          </div>
                          <div className="text-right">
                            <small style={{ fontWeight: 400, fontSize: 15 }}>
                              Исходящий
                            </small>
                            <h2 className="card-title">
                              {sumOutTraffic.toFixed(0)} Мб
                            </h2>
                            <small
                              style={{
                                fontWeight: 400,
                                fontSize: 15,
                                textTransform: "lowercase",
                              }}
                            >
                              c {moment.unix(+unixStartTime).format("D.MM.Y")}г.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="el-card__body">
                      <div className="flex flex-column">
                        <div
                          className="text-center"
                          style={{ textAlign: "center" }}
                        >
                          Остаток предоплаченного трафика
                        </div>
                        <div className="flex justify-between">
                          <div className="text-left">
                            <h2 className="card-title">
                              {units?.incoming ? (
                                <h2 className="card-title">
                                  {units?.incoming?.toFixed(2)} Мб
                                </h2>
                              ) : (
                                <small
                                  style={{ fontWeight: 400, fontSize: 15 }}
                                >
                                  Нет
                                </small>
                              )}
                            </h2>
                          </div>
                          <div className="text-right">
                            <h2 className="card-title">
                              {units?.outgoing ? (
                                <h2 className="card-title">
                                  {units?.outgoing?.toFixed(2)} Мб
                                </h2>
                              ) : (
                                <small
                                  style={{ fontWeight: 400, fontSize: 15 }}
                                >
                                  Нет
                                </small>
                              )}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="el-card__body">
                      <div>
                        <Link to="/traffic/stat">
                          <small>Использованный трафик</small>
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                  <div className="el-card card--warning is-always-shadow">
                    <div className="el-card__header">
                      <div>
                        <i
                          aria-hidden="true"
                          className="fa fa-cube card__icon card__icon--small"
                        ></i>
                        <small style={{ fontWeight: 400, fontSize: 15 }}>
                          Тарифный план
                        </small>
                        <h3 className="card-title">{profile?.tariffName}</h3>
                      </div>
                    </div>
                    {profile?.isJuridical === 0 ? (
                      <div className="el-card__body">
                        <div className="flex align-center justify-between">
                          <Link to="/tariffs/list">
                            <button
                              type="button"
                              className="el-button el-button--warning el-button--small is-plain"
                            >
                              <span>
                                <small>Сменить</small>
                              </span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="el-card__body">
                        <div className="flex align-center justify-between">
                          <Link to="/jurical/tariffs">
                            <button
                              type="button"
                              className="el-button el-button--warning el-button--small is-plain"
                            >
                              <span>
                                <small>Сменить</small>
                              </span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {profile?.isJuridical !== 0 ? (
                  isActiveButtonCreateBill ?
                    <div className="el-col el-col-24 el-col-sm-12 el-col-md-8" style={{ "width": "100%" }}>
                      <button
                        type="button"
                        className="el-button el-button--success el-button--small"
                        style={{ "width": "100%", "fontSize": "16px" }}
                        onClick={() => settingActivateButtonBill()}
                      >
                        <span>
                          <small>Заказать счет</small>
                        </span>
                      </button>
                    </div>
                    : null
                ) : null}


                {profile?.isJuridical === 0 ? (
                  <>
                    {profile?.isActive ? (
                      <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                        <div className="el-card card--success is-always-shadow">
                          <div className="el-card__header">
                            <div>
                              <i
                                aria-hidden="true"
                                className="fa fa-globe card__icon card__icon--small"
                              ></i>
                              <small style={{ fontWeight: 400, fontSize: 15 }}>
                                Добровольная блокировка
                              </small>
                              <h3 className="card-title">Интернет доступен</h3>
                            </div>
                          </div>

                          {isActiveBlockedButton ? (
                            <div className="el-card__body">
                              <div>
                                <button
                                  type="button"
                                  className="el-button el-button--success el-button--small is-plain"
                                  onClick={ActiveButtonBlocked}
                                >
                                  <span>
                                    <small>Заблокировать</small>
                                  </span>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="el-card__body">
                                <div>
                                  <button
                                    type="button"
                                    className="el-button el-button--success el-button--small is-plain"
                                    onClick={toggleModal}
                                  >
                                    <span>
                                      <small>Активировать</small>
                                    </span>
                                  </button>
                                </div>
                              </div>
                              <div className="flex flex-column">
                                <div className="el-card__body">
                                  <small
                                    style={{
                                      textTransform: "none",
                                      fontWeight: 400,
                                      fontSize: 15,
                                      color: "rgb(10, 107, 50)",
                                    }}
                                  >
                                    Дата начала
                                  </small>
                                  <div
                                    style={{
                                      fontWeight: 300,
                                      fontSize: 14,
                                      color: "rgb(10, 107, 50)",
                                    }}
                                  >
                                    <DatePicker
                                      onChange={onChangeStart}
                                      value={valueStart}
                                      minDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 0
                                          )
                                        )
                                      }
                                      maxDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 7
                                          )
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="el-card__body">
                                  <small
                                    style={{
                                      textTransform: "none",
                                      fontWeight: 400,
                                      fontSize: 15,
                                      color: "rgb(10, 107, 50)",
                                    }}
                                  >
                                    Дата окончания
                                  </small>
                                  <div
                                    style={{
                                      fontWeight: 300,
                                      fontSize: 14,
                                      color: "rgb(10, 107, 50)",
                                    }}
                                  >
                                    <DatePicker
                                      onChange={onChangeEnd}
                                      value={valueEnd}
                                      minDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 0
                                          )
                                        )
                                      }
                                      maxDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 90
                                          )
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                        <div className="el-card card--danger py16 is-always-shadow">
                          <div className="el-card__header">
                            <div>
                              <i
                                aria-hidden="true"
                                className="fa fa-lock card__icon"
                              ></i>
                              <h5
                                className="mt-1 mb-0"
                                style={{ fontWeight: 400, fontSize: 15, textTransform: "uppercase" }}
                              >
                                {profile?.BlockedType === 3 ? "Пользовательская блокировка." :
                                  profile?.BlockedType === 2 ? "Административная блокировка." :
                                    profile?.BlockedType === 1 ? "Системная блокировка, недостаточно средств." : ""}

                              </h5>

                            </div>
                          </div>
                          <div className="el-card__body">
                            <div>
                              {profile?.BlockedType === 1 ? (
                                <small style={{ fontWeight: 400, fontSize: 15 }}>
                                  СУММА ПОПОЛНЕНИЯ -{" "}
                                  {parseFloat(payReq).toFixed(0)} ₽
                                </small>
                              ) : null}

                              <div>
                                {profile?.BlockedType === 3 ? (
                                  <button
                                    type="button"
                                    className="el-button el-button--danger el-button--small"
                                    onClick={activatedDisabledBlocked}
                                  >
                                    <span>
                                      <small>Разблокировать</small>
                                    </span>
                                  </button>
                                ) : null}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Turbo mode */}
                    <>
                      {turboData !== 0 ? (
                        <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                          <div className="el-card card--success is-always-shadow">
                            <div className="el-card__header">
                              <div>
                                <i
                                  aria-hidden="true"
                                  className="fa fa-rocket card__icon card__icon--small "
                                ></i>
                                <small>
                                  Турбо режим - остаток
                                </small>
                                <h2 className="card-title flex justify-between">
                                  <span>
                                    Остаток
                                  </span>
                                  <span>{(turboData / 1000000).toFixed(2)} Мб</span>
                                </h2>
                              </div>
                            </div>
                            <div className="el-card__body">
                              <div className="flex align-center justify-between">
                                <div>

                                </div>
                                <div>
                                  <span>
                                    <button
                                      type="button"
                                      className="el-button el-button--text el-button--small el-popover__reference"
                                      aria-describedby="el-popover-5546"
                                      tabIndex={0}
                                    >
                                      <span></span>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {service?.map((el) => (
                        <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                          <div className="el-card card--success is-always-shadow">
                            <div className="el-card__header">
                              <div>
                                <i
                                  aria-hidden="true"
                                  className="fa fa-rocket card__icon card__icon--small "
                                ></i>
                                <small>
                                  Турбо режим <span>{el.Name}</span>
                                </small>
                                <h2 className="card-title flex justify-between">
                                  <span>
                                    {el.TurboIncomingLimit / 1000000} Мб
                                  </span>
                                  <span>{el.Cost} ₽</span>
                                </h2>
                              </div>
                            </div>
                            <div className="el-card__body">
                              <div className="flex align-center justify-between">
                                <div>
                                  <button
                                    type="button"
                                    className={classNames(
                                      el.TurboStatus
                                        ? "el-button el-button--success el-button--small is-disabled"
                                        : "el-button el-button--success el-button--small"
                                    )}
                                    onClick={() => {
                                      if (!el.TurboStatus)
                                        changeTurbo(el.ID, el.TurboID);
                                    }}
                                  >
                                    <span>
                                      <small>Подключить</small>
                                    </span>
                                  </button>
                                </div>
                                <div>
                                  <span>
                                    <button
                                      type="button"
                                      className="el-button el-button--text el-button--small el-popover__reference"
                                      aria-describedby="el-popover-5546"
                                      tabIndex={0}
                                    >
                                      <span>О режиме</span>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>


                    {/* End turbomode */}
                  </>
                ) : null}
              </div>

              {profile?.isJuridical === 0 ? (
                <>
                  <div className="el-card mt-4 card--warning is-always-shadow">
                    <div className="el-card__header">
                      <div>
                        <i
                          aria-hidden="true"
                          className="fas fa-university card__icon"
                          style={{ fontSize: 80, top: 5 }}
                        ></i>
                        <h3>ПОПОЛНИТЬ СЧЕТ</h3>
                        <p
                          className="text-thin"
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: 400,
                          }}
                        >
                          Рекомендовано -{" "}
                          <span style={{ fontWeight: 400, fontSize: 15 }}>
                            {parseFloat(payReq).toFixed(0)} ₽
                          </span>
                        </p>
                      </div>
                    </div>
                    {isPay ? (
                      <div className="el-card__body">
                        <div>
                          <form
                            data-v-42bf1688=""
                            className="el-form mt-3"
                            onSubmit={PayOn}
                          >
                            <div
                              data-v-42bf1688=""
                              className="el-form-item is-required el-form-item--small"
                              style={{ maxWidth: "100%" }}
                            >
                              <label className="el-form-item__label">
                                Сумма
                              </label>
                              <div className="el-form-item__content">
                                <div
                                  data-v-42bf1688=""
                                  className="el-input el-input--small el-input--suffix"
                                >
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    className="el-input__inner"
                                    placeholder={parseFloat(payReq).toFixed(0)}
                                    value={mount}
                                    onChange={(e) => setMount(e.target.value)}
                                  />
                                  <span className="el-input__suffix">
                                    <span className="el-input__suffix-inner"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-42bf1688=""
                              className="el-form-item is-required el-form-item--small"
                              style={{ maxWidth: "100%" }}
                            >
                              <label className="el-form-item__label">
                                Электронная почта
                              </label>

                              <div className="el-form-item__content">
                                <div
                                  data-v-42bf1688=""
                                  className="el-input el-input--small el-input--suffix"
                                >
                                  <input
                                    type="email"
                                    autoComplete="off"
                                    className="el-input__inner"
                                    placeholder="Укажите вашу эл.почту"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                  <span className="el-input__suffix">
                                    <span className="el-input__suffix-inner"></span>
                                  </span>
                                </div>
                                {errEmail ? (
                                  <span className="el-form-item__label">
                                    <small style={{ color: "red" }}>
                                      {errEmail}
                                    </small>
                                  </span>
                                ) : null}
                              </div>
                            </div>

                            <button
                              data-v-42bf1688=""
                              type="submit"
                              className="el-button el-button--success el-button--small "
                            >
                              <span>
                                <small data-v-42bf1688="">Оплатить</small>
                              </span>
                            </button>
                          </form>
                        </div>
                      </div>
                    ) : (
                      <div className="el-card__body flex justify-center">
                        <div className="el-col el-col-24 el-col-sm-12 el-col-md-8">
                          <h1 className="">Идет обработка платежа</h1>
                          <div className="flex justify-center align-center">
                            <h2 className="flex justify-center align-center">
                              Ожидайте
                            </h2>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : null}

              {isLoadingSheet ?
                <div data-v-dde546dc="" className="el-main">
                  <div
                    data-v-dde546dc=""
                    className="dashboard justify-center align-center flex"
                  >
                    <TailSpin color="#d6f1dc" height={100} width={100} />
                  </div>
                </div>
                : null}

              {isOpenJuridicalBillForm ?
                <>
                  <div className="el-card mt-4 card--warning is-always-shadow">
                    <div className="el-card__header">
                      <div>
                        <i
                          aria-hidden="true"
                          className="fas fa-university card__icon"
                          style={{ fontSize: 80, top: 5 }}
                        ></i>
                        <h3>Сформировать счет на оплату (Ваш ИНН: {profile?.taxNumber} и ДОГОВОР: № {profile?.contractID})</h3>
                        <p
                          className="text-thin"
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: 400,
                          }}
                        >
                          <p style={{ "textTransform": "none", fontWeight: 300, fontSize: 16 }}>Выделение внешнего IP адреса: {profile?.IP === true ? "Услуга подключена" : "Услуга не подключена"}</p>
                        </p>
                      </div>
                    </div>
                    <div className="el-card__body">
                      <div>
                        <div
                          data-v-42bf1688=""
                          className="el-form-item is-required el-form-item--small"
                          style={{ maxWidth: "100%" }}
                        >
                          <label className="el-form-item__label">
                            Укажите сумму платежа
                          </label>
                          <div className="el-form-item__content">
                            <div
                              data-v-42bf1688=""
                              className="el-input el-input--small el-input--suffix"
                            >
                              <input
                                type="text"
                                autoComplete="off"
                                className="el-input__inner"
                                value={mount}
                                onChange={(e) => setMount(e.target.value)}
                              />
                              <span className="el-input__suffix">
                                <span className="el-input__suffix-inner"></span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <button className="el-button el-button--success el-button--small" onClick={createAccounts}>Сформировать</button>
                      </div>
                    </div>
                  </div>
                </>
                : null}
              {sheetActive ?
                <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                  <div>
                    <h1 style={{ textAlign: "center", marginTop: "20px" }}>Ваш счет №{NumNumber1c} сформирован.</h1>
                  </div>
                  <div>
                    <h2>Ожидайте загрузки!</h2>
                  </div>
                </div>

                : null}
            </div>
          </div>
        </div>
      </div>
      {notification ? <Notification message={errors} /> : null}
      {successNotification ? <SuccessNotification message={errors} /> : null}
    </div>
  ) : (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside isJurical={profile?.isJuridical} />
      <div data-v-dde546dc="" className="el-main">
        <div
          data-v-dde546dc=""
          className="dashboard justify-center align-center flex"
        >
          <TailSpin color="#d6f1dc" height={100} width={100} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
